(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mons-pdp-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mons-pdp-delivery')) {
    customElements.define('mons-pdp-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.form = this.querySelector('form');
        const chile = Array.from(this.querySelector('[data-countries]').options).find(o => o.value === 'Chile');
        if (chile) {
          const provinces = JSON.parse(chile.dataset.provinces || '[]');
          provinces.forEach(([value, label]) => this.form.elements.province.add(new Option(label, value)));
        }
        this.form.addEventListener('submit', e => { e.preventDefault(); this.calculate(); });
        this.clearQuote = () => { this.controller?.abort(); this.controller = null; this.form.querySelector('button').disabled = false; this.querySelector('[data-rates]').replaceChildren(); this.querySelector('[data-status]').textContent = ''; };
        this.form.addEventListener('input', this.clearQuote);
        this.parentSection = this.closest('.shopify-section');
        this.parentSection?.addEventListener('change', this.clearQuote);
      }
      disconnectedCallback() { this.controller?.abort(); this.parentSection?.removeEventListener('change', this.clearQuote); }
      async calculate() {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const timer = setTimeout(() => controller.abort(), 30000);
        const status = this.querySelector('[data-status]');
        const results = this.querySelector('[data-rates]');
        const button = this.form.querySelector('button');
        button.disabled = true;
        results.replaceChildren();
        status.textContent = this.messages.loading;
        const request = async (path, options = {}) => {
          const response = await fetch(this.dataset.root + path, {credentials:'same-origin', cache:'no-store', ...options, signal:controller.signal});
          if (!response.ok) throw new Error('request_failed');
          return response.json();
        };
        try {
          const cart = await request('cart.js');
          const section = this.closest('.shopify-section');
          const selected = section?.querySelector('product-form-component input[name="id"]')?.value;
          const item = cart.items.find(i => String(i.product_id) === this.dataset.productId && (!selected || String(i.variant_id) === selected));
          if (!item) { status.textContent = this.messages.empty; return; }
          const params = new URLSearchParams({'shipping_address[country]':'Chile'});
          for (const name of ['province','city','address1','zip']) params.set(`shipping_address[${name}]`, this.form.elements[name].value.trim());
          await request('cart/prepare_shipping_rates.json?' + params, {method:'POST'});
          let data = null;
          for (let attempt = 0; attempt < 10; attempt++) {
            if (controller.signal.aborted) throw new Error('cancelled');
            data = await request('cart/async_shipping_rates.json?' + params);
            if (data !== null) break;
            await new Promise(resolve => setTimeout(resolve, 1200));
          }
          if (!data) throw new Error('timeout');
          const rates = data.shipping_rates || [];
          status.textContent = rates.length ? this.messages.success : this.messages.none;
          for (const rate of rates) {
            const li = document.createElement('li');
            const value = Number(rate.price);
            if (!Number.isFinite(value)) continue;
            const price = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {style:'currency',currency:rate.currency || cart.currency || 'CLP'}).format(value);
            li.textContent = `${rate.presentment_name || rate.name}: ${price}`;
            results.append(li);
          }
        } catch (error) {
          if (this.controller === controller && this.isConnected) status.textContent = this.messages.error;
        } finally { clearTimeout(timer); if (this.controller === controller) button.disabled = false; }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mons-pdp-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mons-pdp-details')) {
    customElements.define('mons-pdp-details', class extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('[data-source]');
        if (!source || this.dataset.organized) return;
        this.dataset.organized = 'true';
        const nodes = Array.from(source.childNodes);
        const heading = node => node.nodeType === 1 && (/^H[2-4]$/.test(node.tagName) || (node.tagName === 'P' && node.children.length === 1 && node.firstElementChild.tagName === 'STRONG' && node.textContent.trim() === node.firstElementChild.textContent.trim() && node.textContent.length < 90));
        if (!nodes.some(heading)) return;
        let target = source;
        let previous = source.closest('details');
        for (const node of nodes) {
          if (heading(node) && node.textContent.trim()) {
            const row = document.createElement('details');
            const summary = document.createElement('summary');
            summary.textContent = node.textContent.trim();
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden','true');
            icon.textContent = '＋';
            summary.append(icon);
            target = document.createElement('div');
            target.className = 'mons-pdp-details__body rte';
            row.append(summary,target);
            previous.after(row);
            previous = row;
            node.remove();
          } else if (target !== source) target.append(node);
        }
        if (!source.textContent.trim() && !source.querySelector('img,video,iframe')) source.closest('details').remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
